import { closeModal } from './close-modal';
import { getLastModalType } from '../selectors/modal-selectors';

export default function closeCurrentModal() {
  return (dispatch, getState) => {
    const type = getLastModalType(getState());
    if (!type) {
      return;
    }
    dispatch(closeModal({ type, resolve: true }));
  };
}
